import EnrollmentDetail from "../../admin/enrollments/EnrollmentDetail";

export default function CoachEnrollmentDetail() {
    return <EnrollmentDetail role="COACH" />;
}
